import Page from '@components/Page/Page'
import { BooleanTag } from '@components/utils/BooleanTag'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { AdyenConfig as AdyenConfigModel } from '@models/venue/integrations/AdyenConfig'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getAdyenConfigs,
  selectAdyenConfigs,
} from '@store/venue/integrations/AdyenConfigReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'

const IntegrationsAdyenPage = () => {
  const dispatch = useAppDispatch()
  const adyenConfigs = useAppSelector(selectAdyenConfigs())
  const { query, isLoading } = useAppSelector((state) => state.adyenConfig)

  const columns: TableColumnsType<AdyenConfigModel> = [
    {
      title: 'Merchant account',
      dataIndex: 'merchantAccount',
    },
    {
      title: 'Environment',
      dataIndex: 'environment',
    },
    {
      title: 'Webhook integration',
      render: (record: AdyenConfigModel) => (
        <BooleanTag value={record.webhookConfigured} />
      ),
    },
  ]

  const fetchAdyenConfigs = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(getAdyenConfigs(newQuery))
  }

  const { handleTableChange } = useTableUrlSync<AdyenConfigModel>({
    onParamsChange: fetchAdyenConfigs,
  })

  return (
    <Page
      permissions={Permission.listAdmin}
      pageTitle={{ title: 'Adyen', level: 4 }}
    >
      <SBTable
        columns={columns}
        dataSource={adyenConfigs}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default IntegrationsAdyenPage
